import GroupsIcon from "@mui/icons-material/Groups";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import SchoolIcon from "@mui/icons-material/School";
import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import UserAccountingInfo from "./UserAccountingInfo/UserAccountingInfo";
import EditUserAccountingInfo from "./EditUserAccountingInfo/EditUserAccountingInfo";
import AddBankAccounts from "./AddBankAccounts/AddBankAccounts";
import {
  getUserAccountingInfoApi,
  setUserAccountingInfoApi,
  addBankAccountApi,
  getBankAccountsApi,
} from "../../../../../services/accountingApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";

function UserAccounting() {
  const [userAccountTab, setUserAccountTab] = useState("UserAccountingInfo");
  const [newBankAccount, setNewBankAccount] = useState({
    bankName: "",
    bankCartNumber: "",
    bankAccountNumber: "",
    bankShaba: "",
  });
  const [userAccountingInfo, setUserAccountingInfo] = useState({
    firstName: "llmmt-loading",
    lastName: "llmmt-loading",
    mobileNumber: "llmmt-loading",
    identificationCardNumber: "llmmt-loading",
    // identificationCard: "",
  });
  const [bankCardsData, setBankCardsData] = useState({ docs: [] });
  const [controlAlert, setControlAlert] = useState({
    open: true,
    message: "لطفا صبر کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });
  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getBankCardsDataFromBack("getBankAccountsApi", {}, PageAndPerPageValue);
  };
  const [pageAndPerPage, setPageAndPerPage] = useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const handleNewBankAccount = (key, value) => {
    const newValue = {};
    newValue[key] = value;
    setNewBankAccount({ ...newBankAccount, ...newValue });
  };
  const getUserAccountingInfo = async () => {
    try {
      const data = {};
      const response = await getUserAccountingInfoApi(data);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        if (
          resData["data"] &&
          resData["data"]["data"] &&
          resData["data"]["data"].length > 0
        ) {
          setUserAccountingInfo(resData["data"]["data"][0]);
        } else {
          customToastify("info", resData["message"]);
        }
      }
    } catch (error) {
      setUserAccountingInfo({
        firstName: "llmmt-errorLoading",
        lastName: "llmmt-errorLoading",
        mobileNumber: "llmmt-errorLoading",
        identificationCardNumber: "llmmt-errorLoading",
      });
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      console.error(error);
    }
  };

  const getBankCardsDataFromBack = async (request, data, paginateData = {}) => {
    try {
      setControlAlert({
        open: true,
        message: "لطفا صبر کنید",
        severity: "warning",
        SkeletonDisplay: "Block",
      });
      setBankCardsData({ docs: [] });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "getBankAccountsApi") {
        let response = await getBankAccountsApi(data, paginate);
        const resData = checkResponseData(response);
        // console.log("amir");
        if (resData["success"]) {
          setBankCardsData(resData["data"]);
          setControlAlert({
            open: false,
            message: "جواب آمد",
            severity: "warning",
            SkeletonDisplay: "none",
          });
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            resData["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          setControlAlert({
            open: true,
            message: "مشکلی پیش آمده است",
            severity: "warning",
            SkeletonDisplay: "none",
          });
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      if (errData["titles"] || errData["message"])
        setControlAlert({
          open: true,
          message: errData["message"] || errData["titles"],
          severity: "warning",
          SkeletonDisplay: "none",
        });
    }
  };

  const setUserAccountingInfoToBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await setUserAccountingInfoApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setUserAccountingInfo(resData["data"]["data"][0]);
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      console.error(error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  const addBankAccountToBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await addBankAccountApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        setNewBankAccount(resData["data"]["data"][0]);
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 }); console.error(error);
    }
  };

  const handleSetUserAccountingInfo = (key, value) => {
    const newValue = {};
    newValue[key] = value;
    setUserAccountingInfo({ ...userAccountingInfo, ...newValue });
  };

  const getData = async () => {
    await getUserAccountingInfo();
    await getBankCardsDataFromBack("getBankAccountsApi", {}, pageAndPerPage);
  };
  useEffect(() => {
    getData();
  }, []);

  const handleAcademyTab = (e) => {
    setUserAccountTab(e.currentTarget.value);
  };
  const ManageAccountingContent = (selected) => {
    switch (selected) {
      case "UserAccountingInfo":
        return (
          <UserAccountingInfo
            userAccountingInfo={userAccountingInfo}
            bankCardsData={bankCardsData}
            setNumberPageAndPerPage={setNumberPageAndPerPage}
            controlAlert={controlAlert}
          />
        );
      case "EditUserAccountingInfo":
        return (
          <EditUserAccountingInfo
            userAccountingInfo={userAccountingInfo}
            handleSetUserAccountingInfo={handleSetUserAccountingInfo}
            setUserAccountingInfoToBack={setUserAccountingInfoToBack}
          />
        );
      case "AddBankAccounts":
        return (
          <AddBankAccounts
            handleNewBankAccount={handleNewBankAccount}
            addBankAccountToBack={addBankAccountToBack}
            newBankAccount={newBankAccount}
          />
        );
      case "masterOfAcademy":
        return "<Masters/>";
      default:
        return "Error";
    }
  };
  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <Tooltip title=" مشخصات و کارت های من" arrow>
          <Button
            value="UserAccountingInfo"
            onClick={handleAcademyTab}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={
                userAccountTab == "UserAccountingInfo" ? "success" : "warning"
              }
              icon={<SchoolIcon />}
              label={detectSize600px ? "مشخصات و کارت های من" : ""}
            />
          </Button>
        </Tooltip>

        <Tooltip title="ویرایش مشخصات من" arrow>
          <Button
            value="EditUserAccountingInfo"
            onClick={handleAcademyTab}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={
                userAccountTab == "EditUserAccountingInfo" ? "error" : "warning"
              }
              icon={<SettingsSuggestIcon />}
              label={detectSize600px ? "ویرایش مشخصات من" : ""}
            />
          </Button>
        </Tooltip>

        <Tooltip title="ثبت حساب جدید" arrow>
          <Button
            value="AddBankAccounts"
            onClick={handleAcademyTab}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={userAccountTab == "AddBankAccounts" ? "error" : "warning"}
              icon={<GroupsIcon />}
              label={detectSize600px ? "ثبت حساب جدید" : ""}
            />
          </Button>
        </Tooltip>

        <hr />
        {ManageAccountingContent(userAccountTab)}
      </Box>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={1300}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Grid>
  );
}

export default UserAccounting;
